var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BBA262",
    d: "M25.6 0C29.135 0 32 2.865 32 6.4v19.2c0 3.535-2.865 6.4-6.4 6.4H6.4C2.865 32 0 29.135 0 25.6V6.4C0 2.865 2.865 0 6.4 0h19.2zm0 1.067H6.4c-2.868 0-5.207 2.263-5.328 5.102l-.005.231v19.2c0 2.868 2.263 5.207 5.102 5.328l.231.005h19.2c2.868 0 5.207-2.263 5.328-5.102l.005-.231V6.4c0-2.868-2.263-5.207-5.102-5.328l-.231-.005z",
    transform: "translate(-260 -92) translate(236 68) translate(24.509 24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A19",
    d: "M9.532 20.399l2.662-8.538h-1.28l-1.997 6.554L6.96 11.86H5.333L7.97 20.4h1.562zm6.592.128c1.792 0 2.97-1.075 3.238-2.931l-1.433-.167c-.128 1.14-.87 1.805-1.69 1.805-1.14 0-1.869-1.088-1.869-3.136 0-1.984.64-3.123 1.818-3.123.883 0 1.446.538 1.74 1.933l1.434-.154c-.32-1.958-1.446-3.02-3.187-3.02-2.202 0-3.469 1.843-3.469 4.364 0 2.266.999 4.429 3.418 4.429zm4.864-.128l.665-2.035h3.277l.691 2.035h1.639l-2.867-8.538H22.51L19.669 20.4h1.319zm3.533-3.264h-2.484l1.242-3.814 1.242 3.814z",
    transform: "translate(-260 -92) translate(236 68) translate(24.509 24)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVca);
export default __webpack_public_path__ + "static/media/vca.b10d5fcb7a11eca0824f9094b50a4fb9.svg";
export { ForwardRef as ReactComponent };